import { createAction } from '@reduxjs/toolkit';

// Basic examination CRUD actions
export const getExamination = {
    request: createAction('examination/get/request'),
    success: createAction('examination/get/success'),
    failed: createAction('examination/get/failed'),
};

export const createExamination = {
    request: createAction('examination/create/request'),
    success: createAction('examination/create/success'),
    failed: createAction('examination/create/failed'),
};

export const getExaminationById = {
    request: createAction('examination/getById/request'),
    success: createAction('examination/getById/success'),
    failed: createAction('examination/getById/failed'),
};

export const updateExamination = {
    request: createAction('examination/update/request'),
    success: createAction('examination/update/success'),
    failed: createAction('examination/update/failed'),
};

export const deleteExamination = {
    request: createAction('examination/delete/request'),
    success: createAction('examination/delete/success'),
    failed: createAction('examination/delete/failed'),
};

// Examination session actions
export const startExamination = {
    request: createAction('examination/start/request'),
    success: createAction('examination/start/success'),
    failed: createAction('examination/start/failed'),
};

export const pauseExamination = {
    request: createAction('examination/pause/request'),
    success: createAction('examination/pause/success'),
    failed: createAction('examination/pause/failed'),
};

export const completeExamination = {
    request: createAction('examination/complete/request'),
    success: createAction('examination/complete/success'),
    failed: createAction('examination/complete/failed'),
};

// Examination question actions
export const getExaminationQuestions = {
    request: createAction('examination/getQuestions/request'),
    success: createAction('examination/getQuestions/success'),
    failed: createAction('examination/getQuestions/failed'),
};

export const submitExaminationAnswer = {
    request: createAction('examination/submitAnswer/request'),
    success: createAction('examination/submitAnswer/success'),
    failed: createAction('examination/submitAnswer/failed'),
};

export const getExaminationTimeStatus = {
    request: createAction('examination/getTimeStatus/request'),
    success: createAction('examination/getTimeStatus/success'),
    failed: createAction('examination/getTimeStatus/failed'),
};

// Individual question loading actions (lightweight approach)
export const loadQuestionById = {
    request: createAction('examination/loadQuestion/request'),
    success: createAction('examination/loadQuestion/success'),
    failed: createAction('examination/loadQuestion/failed'),
};

// Navigation actions
export const navigateToQuestion = createAction('examination/navigateToQuestion');
export const navigateToSection = createAction('examination/navigateToSection');

// Combined actions
export const createExaminationAndNavigate = {
    request: createAction('examination/createAndNavigate/request'),
    success: createAction('examination/createAndNavigate/success'),
    failed: createAction('examination/createAndNavigate/failed'),
};

export const clearExaminationError = createAction('examination/clearError');